import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ["section"]
  static values = {
    routineSlug: String
  }

  // Also runs for sections streamed in after an edit replaces them.
  sectionTargetConnected(section) {
    this.createRoutineSortable(section)
  }

  // From routine-edit-mode: edit mode drags straight from each row's handle;
  // otherwise a long press anywhere on the row starts a drag.
  setEditing({ detail: { editing } }) {
    this.editing = editing
    this.sectionTargets.forEach((section) => {
      const sortable = Sortable.get(section)
      Object.entries(this.dragOptions()).forEach(([name, value]) => sortable?.option(name, value))
    })
  }

  dragOptions() {
    return this.editing ? { handle: ".drag-handle", delay: 0 } : { handle: ".sort-handle", delay: 150 }
  }

  createRoutineSortable(element) {
    const csrfToken = document.querySelector("[name='csrf-token']").content

    new Sortable(element, {
      ...this.dragOptions(),
      easing: "cubic-bezier(1, 0, 0, 1)",
      ghostClass: 'invisible',
      chosenClass: "!bg-warm-gray-200",
      // Pressing a row's Edit/Remove buttons, or anywhere in its Edit drawer
      // (a <dialog> inside the row), mustn't pick up or highlight the row,
      // nor be cancelled.
      filter: "dialog, [data-routine-sort-ignore]",
      preventOnFilter: false,
      animation: 150,
      delayOnTouchOnly: true,
      onEnd: (evt) => {
        // Every product's position, so an interchangeable group (one sortable
        // item listing its members in data-ids) keeps its members together.
        const newOrder = {}
        const sortableItems = evt.to.getElementsByClassName('sortable-item')
        let position = 0

        Array.from(sortableItems).forEach((el, index) => {
          const ids = (el.dataset.ids || el.dataset.id).split(',')

          ids.forEach((id) => {
            position += 1
            newOrder[id] = position
          })

          // Update displayed text for both owner and non-owner views
          // For non-owner views (has class 'step-id')
          const stepElements = el.querySelectorAll('.step-id')
          stepElements.forEach((obj) => {
            obj.textContent = index + 1
          })

          // For owner views (button with data-order span)
          const ownerStepElement = el.querySelector('span[data-order]')
          if (ownerStepElement) {
            // Only update if not logged (when showing order number, not checkmark)
            ownerStepElement.setAttribute('data-order', index + 1)
            if (ownerStepElement.textContent.trim() !== '' && !ownerStepElement.querySelector('svg')) {
              ownerStepElement.textContent = index + 1
            }
          }
        })

        const formData = new FormData()
        formData.append('routine_products', JSON.stringify(newOrder))

        fetch(`/routines/routine-products/${this.routineSlugValue}`, {
          method: "PATCH",
          headers: {
            "X-CSRF-Token": csrfToken
          },
          body: formData
        })
      }
    })
  }
}
